import { type ReactElement } from "react";

import { isInApp, useNavigation, type LinkProps } from "./navigation-provider";

export const Link = ({ to, children, ...rest }: LinkProps): ReactElement => {
  const { routes, RouterLink } = useNavigation();
  return isInApp(to, routes) ? (
    <RouterLink to={to} {...rest}>
      {children}
    </RouterLink>
  ) : (
    <a href={to} {...rest}>
      {children}
    </a>
  );
};
